import { showSuccessApiResponseSnackbar } from '../snackbar';
const showApiSuccessSnackbar = (props) => () => {
    if (!props)
        return;
    showSuccessApiResponseSnackbar(props);
};
export { showApiSuccessSnackbar };
